import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { useBusinessIdPathParam } from 'lib/navigation/hooks/useBusinessIdPathParam/useBusinessIdPathParam'
import { getBusinessTraits } from 'lib/helpers/getBusinessTraits/getBusinessTraits'
import { BusinessTraitsHook_businessDocument } from './useBusinessTraits.graphql'

export const useBusinessTraits = () => {
  const businessId = useBusinessIdPathParam()
  const { data: { business = null } = {} } = useQuery(BusinessTraitsHook_businessDocument, {
    fetchPolicy: 'cache-and-network',
    variables: { businessId },
    skip: !businessId,
  })

  return useMemo(() => (business ? getBusinessTraits(business) : null), [business])
}
